import type { QueryClient } from '@tanstack/react-query';
import { CHAT_SKILLS_QUERY_KEY } from 'src/UI/app-container/chats/useChatSkills';

/** Everything that shows which skills the company has. The library listing is included
 * because it marks a curated or community skill as already added from the company's own copy. */
export function invalidateCompanySkillQueries(queryClient: QueryClient) {
  return Promise.all([
    queryClient.invalidateQueries({ queryKey: ['tenant', 'custom-skills'] }),
    queryClient.invalidateQueries({ queryKey: CHAT_SKILLS_QUERY_KEY }),
    queryClient.invalidateQueries({ queryKey: ['skill-library'] }),
  ]);
}
